import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_ALL_SUBSCTIPTION_PLAN_REQUEST =
  'FETCH_ALL_SUBSCTIPTION_PLAN_REQUEST'
const FETCH_ALL_SUBSCTIPTION_PLAN_SUCCESS =
  'FETCH_ALL_SUBSCTIPTION_PLAN_SUCCESS'
const FETCH_ALL_SUBSCTIPTION_PLAN_FAILURE =
  'FETCH_ALL_SUBSCTIPTION_PLAN_FAILURE'

const CREATE_SUBSCTIPTION_PLAN_REQUEST = 'CREATE_SUBSCTIPTION_PLAN_REQUEST'
const CREATE_SUBSCTIPTION_PLAN_SUCCESS = 'CREATE_SUBSCTIPTION_PLAN_SUCCESS'
const CREATE_SUBSCTIPTION_PLAN_FAILURE = 'CREATE_SUBSCTIPTION_PLAN_FAILURE'

const RENEW_SUBSCTIPTION_PLAN_REQUEST = 'RENEW_SUBSCTIPTION_PLAN_REQUEST'
const RENEW_SUBSCTIPTION_PLAN_SUCCESS = 'RENEW_SUBSCTIPTION_PLAN_SUCCESS'
const RENEW_SUBSCTIPTION_PLAN_FAILURE = 'RENEW_SUBSCTIPTION_PLAN_FAILURE'

const DELETE_SUBSCTIPTION_PLAN_REQUEST = 'DELETE_SUBSCTIPTION_PLAN_REQUEST'
const DELETE_SUBSCTIPTION_PLAN_SUCCESS = 'DELETE_SUBSCTIPTION_PLAN_SUCCESS'
const DELETE_SUBSCTIPTION_PLAN_FAILURE = 'DELETE_SUBSCTIPTION_PLAN_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  subscriptionPlanList: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_SUBSCTIPTION_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ALL_SUBSCTIPTION_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        subscriptionPlanList: action.payload
      }
    case FETCH_ALL_SUBSCTIPTION_PLAN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_SUBSCTIPTION_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_SUBSCTIPTION_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_SUBSCTIPTION_PLAN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case RENEW_SUBSCTIPTION_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case RENEW_SUBSCTIPTION_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case RENEW_SUBSCTIPTION_PLAN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_SUBSCTIPTION_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_SUBSCTIPTION_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_SUBSCTIPTION_PLAN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export const getAllSubsctiptionPlanList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ALL_SUBSCTIPTION_PLAN_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      const response = await API.get(EndPoints.SUBSCRIPTION_PLAN + `/getAll`, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: FETCH_ALL_SUBSCTIPTION_PLAN_SUCCESS,
        payload: response.data
      })
    } catch (error) {
      dispatch({
        type: FETCH_ALL_SUBSCTIPTION_PLAN_FAILURE
      })
    }
  }
}

export const createSubscriptionPlan = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_SUBSCTIPTION_PLAN_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.SUBSCRIPTION_PLAN, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: CREATE_SUBSCTIPTION_PLAN_SUCCESS
      })
    } catch (error) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_SUBSCTIPTION_PLAN_FAILURE
      })
    }
  }
}

export const renewSubscriptionPlan = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: RENEW_SUBSCTIPTION_PLAN_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.SUBSCRIPTION_PLAN + `/renew`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: RENEW_SUBSCTIPTION_PLAN_SUCCESS
      })
    } catch (error) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: RENEW_SUBSCTIPTION_PLAN_FAILURE
      })
    }
  }
}

export const deleteSubscriptionPlan = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_SUBSCTIPTION_PLAN_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(`${EndPoints.SUBSCRIPTION_PLAN}/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })

      dispatch({
        type: DELETE_SUBSCTIPTION_PLAN_SUCCESS
      })
    } catch (error) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_SUBSCTIPTION_PLAN_FAILURE
      })
    }
  }
}
